import {Modal} from 'bootstrap';
import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-invoice-select',
  templateUrl: './invoice-select.component.html',
  styleUrls: ['./invoice-select.component.css'],
  standalone: false
})
export class InvoiceSelectComponent extends TypeaheadBase implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;

  @Output() testInvoiceEmit = new EventEmitter<string>();
  @Output() updateInvoiceEmit = new EventEmitter<string>();
  @Output() selectInvoiceEmit = new EventEmitter<string>();
  public detail = {id: null};

  invoiceTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.invoiceName, 15);

  constructor() {
    super();
  }

  ngOnInit() {
  //  console.log(this.vm);
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }
  testInvoice() {
    this.testInvoiceEmit.emit();
  }

  onInvoiceBlur(typeahead: any) {
    if (typeahead?.isPopupOpen?.()) {
      return;
    }
    this.testInvoice();
  }

  updateInvoice() {
    this.updateInvoiceEmit.emit();
  }

  selectInvoice(InvoiceId) {
    // $('#InvoiceSelect').modal('hide');
    this.selectInvoiceEmit.emit(InvoiceId);
  }
}
